import React from "react";
import { BOM } from "../../../../services/definedMethod";
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Divider,
  Typography,
} from "antd";
import TextArea from "antd/es/input/TextArea";

const { Text } = Typography;

const DetailsForm = (props) => {
  const {
    handleIncludeInBorrowerCycle,
    includeInBorrowerCycle,
    onFinish,
    form,
    initialValues,
  } = props;

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={initialValues}
      style={{ margin: 30 }}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Product Name</Text>}
            name={"name"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder="Please enter a value" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Short Name</Text>}
            name={"shortName"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder="Please enter a value" maxLength={4} />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Fund</Text>} name={"fundId"}>
            <Select
              options={props.fundsData}
              placeholder="Please select a value"
              showSearch
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name="startDate" label={<Text>Start Date</Text>}>
            <DatePicker style={{ width: "100%", height: 35 }} />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item name="closeDate" label={<Text>Close Date</Text>}>
            <DatePicker style={{ width: "100%", height: 35 }} />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={"Include In Customer Loan Counter"}
            name="includeInBorrowerCycle"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              onChange={handleIncludeInBorrowerCycle}
              value={includeInBorrowerCycle}
              showSearch
            />{" "}
          </Form.Item>
        </Col>

        <Divider orientation="left" orientationMargin="0" />

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Description</Text>}
            name={"description"}
            rules={[
              {
                type: "string",
              },
            ]}
          >
            <TextArea
              style={{ width: "45vh", height: "15vh" }}
              placeholder="Please enter a description"
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default DetailsForm;
